module.exports = __webpack_public_path__ + "img/logo.a1afd12a.png";